export default "__VITE_ASSET__7ac1a7c9__"